import { Box } from '@chakra-ui/react';
import React from 'react'
import GitHubCalendar from 'react-github-calendar';
import {useEffect} from 'react'
import Aos from 'aos'
import "aos/dist/aos.css"


const GithubStats = () => {

  useEffect(() => {
    Aos.init({duration:500})
   
  }, [])



  return (
    <div 
    data-aos-offset="500"
    data-aos-duration="500">
    <h1 style={{textAlign:"center",fontSize:"50px",marginTop:"30px",marginBottom:"30px"}}>Github Stats</h1>
    <div style={{display:"flex",justifyContent:"center",margin:"auto",bgColor:"black",flexWrap:"wrap"}}>
      <div id="calendar" data-aos="fade-right">

<GitHubCalendar  username="uzairshaikh123"  />
      </div>

</div>
<div style={{display:"flex",flexWrap:"wrap",margin:"auto",justifyContent:"space-around"}}>

<div data-aos="fade-right"  >

  <img   id="github-top-langs" className="github-stats" src="https://github-readme-stats.vercel.app/api/top-langs/?username=uzairshaikh123&layout=compact&show_icons=true&theme=radical" alt="github-top-langs" />
</div>
<div data-aos="flip-left"  >

  <img id="github-streak-stats" className="github-stats" src="https://github-readme-streak-stats.herokuapp.com?user=uzairshaikh123&layout=compact&show_icons=true&theme=radical" alt="github-streak-stats" />


</div> 
<div data-aos="fade-left"  className="calendar">
<img id="github-stats-card" className="github-stats" src="https://github-readme-stats.vercel.app/api?username=uzairshaikh123&layout=compact&show_icons=true&theme=radical" alt="github-stats-card" />
</div>
</div>
    </div>
  )
}

export default GithubStats
// ,